<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                   <sidebar></sidebar> 
                </el-aside>
                <el-main>
                    <headSide  @release="gorelease()"></headSide>
                    <div class="mt-30">
                        <paletteBar :paletteObj="paletteObj" @onPaletteBar="addAngle()"  @onDelPalet ="delAngle()"  @onEditPalet="editAngle()"></paletteBar>
                        <div class="mt-10">
                            <div class="corporate_middle fdw">
                                <div class= "middle_cont" v-for="(item,index) in list" :key="index">
                                    <div class="angle_cox">
                                        <img :src="item.cover" alt="">
                                    </div>
                                    <p class="angle_title mt-10">{{item.title}}</p>
                                    <div class="middle_text fdc"> 
                                       <p>{{item.releaseDate}}</p>
                                        <p>
                                            <span>浏览数 : </span><span>{{item.readCount}}</span>
                                        </p>
                                    </div>
                                    <div class="fcc place mt-15" @click="onDetail(item)">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="item.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                            </div>           
                        </div>
                        <!--分页-->
                        <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination> 
                          <div style="margin-top:20%;">
                            <notList :notCode="notCode"></notList>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {releaseList,expertList,releaseEdit,releaseDel} from '@/api/expert'
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import paletteBar from '../../common/paletteBar'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
      sidebar,headSide,commBanner,titleHead,paletteBar,Pagination,notList
  }, 
  data(){
      return{
        headTitle:'专家视角',
        obj:{
           title:'专家视角',   
           isShow:false,
           roleType:2,
           personalType:9,
        },
         paletteObj:{
            paletteTitle:'发布的文章',
            paletteCount:3,
            paletteName:'添加文章',
			paletteView:'编辑文章',
            paletteText:'删除文章',
            isShow:false,
            isDelete:true,
			isEdit:true
        },
        listQuery:{
           curPage:1,
           limit:5
        },
        list:[],
        total:0,//当前条数
        checkList:[],
        id:'',
        notCode:false,
		agleId:''
      }
  },
  created(){
      this.getList();
      if(this.$store.state.user.userInfo.type ==2){
          this.obj.roleType = 2;
      }
  },
  methods:{
      //添加案列
      addAngle(){
          this.$router.push('/expert_angleAdd')
      },
	  editAngle(){
		 this.$router.push({
		 	 path:'/expert_angleAdd',
		 	 query:{id:this.agleId}
		 }); 
	  },
      //列表
      getList(){
          releaseList(this.listQuery).then((res)=>{
            if(res.code ==0){
               this.list = res.page.list;
               this.paletteObj.paletteCount = res.page.totalCount;
               this.total = res.page.totalCount;  
			   this.list.length == 0 ? this.notCode = true : this.notCode = false;
            }
          }).catch((err)=>{})
      },
      //选中
      onChange(){
        this.checkList.forEach(item =>{
             this.id = item;
        });
      },
	  //删除
	  delAngle(){
		 if(this.checkList.length>0){
			 let params = { id:this.id}
			 releaseDel(params).then((res)=>{
			   if(res.code ==0){
				  this.$message({
					 message:'删除成功！',
					 type: 'success',
					 duration:1000,
					 onClose:()=>{
					   this.getList();
					  }
				   }); 
			   }
			 }).catch((err)=>{})
		 }else{
		    this.$message({
			   message:'至少选择一条数据',
			   type:"warning",
			   duration:1000,
			});
		 } 
	  },
      //分页
      pageChange(item){
        this.listQuery['curPage'] = item.page;
        this.listQuery['limit'] = item.limit;
		this.getList();
      },
      //发布需求
      gorelease(){
          this.$router.push('/demand')
      },
	  onDetail(data){
		this.agleId = data.id;
	  }
  }
}
</script>
<style scoped>
/* .el-aside{
    height: 900px;
} */
.fdw{
  display: flex;
  justify-content: flex-start;
}
.mt-30{
    margin-top: 30px;
}
.corporate_top img{
    width: 65%;
    height: 286px;
}
.corporate_top div{
    height: 286px;
    background: #02B854;
    padding: 40px 30px;
    text-align: left;
}
.angle_cox{
    overflow: hidden;
    height: 164px;
}
.angle_cox img{
 transition: all 0.6s;
}
.angle_cox img:hover{
    transform: scale(1.4);
}
.angle_title{
   overflow: hidden;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 2;
}
.corporate_top div p:first-child{ 
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
}
.corporate_top div p:nth-child(2){    
    margin-top: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
    line-height: 24px;
}
.corporate_top div p:last-child{   
    margin-top: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
}
.corporate_middle{
    margin-top: 15px;
}
.middle_cont{
	width: 32%;
	text-align: left;
	display: flex;
	flex-direction: column;
	margin-bottom: 15px;
	margin-right: 9px;
}
.middle_cont img{
    width: 100%;
    height: 162px;
}
.middle_cont p:nth-child(1){   
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.middle_text{
    margin-top: 15px;
}
.middle_text p:nth-child(1){
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;  
}
.middle_text p:nth-child(2){   
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
}

.el-pagination{
   margin-top: 40px;
}
.corporate_middle>>>.el-checkbox__label{
  display: none;
}
.corporate_middle>>>.el-radio__input.is-checked .el-radio__inner{
   background:#50B035;
   border-color: #50B035;
}

.place>>>.el-radio__input.is-checked .el-radio__inner{
   background:#50B035;
   border-color: #50B035;
}
.place>>> .el-checkbox__inner {
  border-radius: 50%;
  /* border: 1px solid #50b035; */
}
.place >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #50b035;
}

.place >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #50b035;
  border-color: #50b035;
  border-radius: 50%;
}
.place >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #50b035;
}
.place >>> .el-checkbox__inner:hover {
  background-color: #50b035;
}
</style>


// WEBPACK FOOTER //
// src/view/expert/expert_angle.vue